module.exports = __webpack_public_path__ + "static/media/HockeyLogo.5bece2e7.png";